import React from 'react'
import BatmanItem from './BatmanItem'
import SupermanItem from './SupermanItem'
import GreenLanternItem from './GreenLanternItem'
import { v4 as uuidv4 } from 'uuid';
export default function ActionCart(props) {
    const {cartValue}=props
    let elements=[]
    let elementsSum=0
    function handleBatmanGoods(obj){
        obj.tshirts!==0 && createBatmanItem('tshirts',obj.tshirts)
        obj.socks!==0 && createBatmanItem('socks',obj.socks)
        obj.shoes!==0 && createBatmanItem('shoes',obj.shoes)
    }
    function createBatmanItem(item,value)
    {
        elementsSum+=value
        elements.push(<BatmanItem key={uuidv4()}item={item}value={value}/>)
    }
    function handleSupermanGoods(obj){
        obj.tshirts!==0 && createSupermanItem('tshirts',obj.tshirts)
        obj.socks!==0 && createSupermanItem('socks',obj.socks)
        obj.shoes!==0 && createSupermanItem('shoes',obj.shoes)
    }

    function createSupermanItem(item,value)
    {
        elementsSum+=value
        elements.push(<SupermanItem key={uuidv4()} item={item}value={value}/>)
    }
    function handleGreenLanternGoods(obj){
        obj.tshirts!==0 && createGreenLanternItem('tshirts',obj.tshirts)
        obj.socks!==0 && createGreenLanternItem('socks',obj.socks)
        obj.shoes!==0 && createGreenLanternItem('shoes',obj.shoes)
    }
    function createGreenLanternItem(item,value)
    {   elementsSum+=value
        elements.push(<GreenLanternItem key={uuidv4()} item={item}value={value}/>)
    }
    for(let key in cartValue){
        key=='batman'&& handleBatmanGoods(cartValue[key])
        key=='superman'&& handleSupermanGoods(cartValue[key])
        key=='greenlantern'&& handleGreenLanternGoods(cartValue[key])
    }
    return (
        <div className="cart">
            {elements}
            <p>total items :<span>{elementsSum}</span></p>
        </div>
    )
}
